import React, { Fragment, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Menu from "../components/menu.js";
import Navbar from "../components/navbar.js";
import Footer from "../components/footer.js";

function Contact() {
  const formRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Contact | AA_Digitals";
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);

    try {
      const response = await fetch("https://sheetdb.io/api/v1/olt3bwby3t353", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        alert("Form submitted successfully!");
        navigate("/contact");
      } else {
        alert("Failed to submit the form.");
      }
    } catch (error) {
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <Fragment>
      <header className="header-one sticky-header">
        <Menu />
        <Navbar />
      </header>

      <section className="breadcrumb-section bgc" style={{ backgroundImage: "url(assets/img/bread2.jpg)" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="breadcrumb-text">
                <span className="title-tag">Welcome to AA_Digitals</span>
                <h2 className="page-title">Contact us.</h2>
              </div>
            </div>
            <div className="col-md-6">
              <div className="breadcrumb-nav">
                <ul>
                  <li><a href="index.html">Home</a></li>
                  <li className="separator">|</li>
                  <li>Contact</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-area section-gap-bottom bg-dark">
        <div className="contact-maps">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3264.3268148476423!2d80.19897499999999!3d13.046723!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5266c560afe025%3A0x1fe31457b8c16283!2s10%2C%2080%20Feet%20Road%2C%20Sathya%20Garden%2C%20Saligramam%2C%20Chennai%2C%20Tamil%20Nadu%20600093!5e1!3m2!1sen!2sin!4v1744695679572!5m2!1sen!2sin" width="100%" height="auto" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>

        <div className="container">
          <div className="row justify-content-center contact-info-boxes">
            <div className="col-lg-4 col-md-6 col-sm-10">
              <div className="contact-info-box">
                <div className="thumb" style={{ backgroundImage: "url(assets/img/contactimg.jpg)" }}></div>
                <div className="content">
                  <h4 className="title">Office in Chennai</h4>
                  <ul>
                    <li><i className="fal fa-phone"></i>+91 6381643312</li>
                    <li><i className="fal fa-envelope"></i>aadigitalsmarketing@gmail.com</li>
                    <li><i className="fal fa-map-marker-alt"></i>Chennai</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form bg-dark">
            <div className="section-title text-center mb-60">
              <span className="title-tag">Call To Action</span>
              <h2 className="title">Make Your Request</h2>
            </div>

            <form ref={formRef} onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-6 mb-30">
                  <input type="text" placeholder="Full name" name="Name" id="Name" required />
                </div>
                <div className="col-lg-6 mb-30">
                  <input type="email" placeholder="Enter email" name="Email" id="Email" required />
                </div>
                <div className="col-lg-6 mb-30">
                  <input type="tel" placeholder="Mobile Number" name="Number" id="Number" required />
                </div>
                <div className="col-lg-6 mb-30">
                  <input type="text" placeholder="Enter City" name="City" id="City" />
                </div>
                <div className="col-12 mb-30">
                  <select name="Subject" id="Subject">
                    <option value="Website">Website</option>
                    <option value="Mobile App">Mobile App</option>
                    <option value="Graphical design">Graphical design</option>
                    <option value="Logo design">Logo design</option>
                    <option value="SEO">SEO</option>
                    <option value="Social media management">Social media management</option>
                    <option value="Poster Design">Poster Design</option>
                    <option value="Photography">Photography</option>
                  </select>
                </div>
                <div className="col-12 text-center">
                  <button className="main-btn" type="submit">Submit Request</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </Fragment>
  );
}

export default Contact;
